/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../config/api-config';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

@Injectable({providedIn: 'root'})
export class BidUpdatesApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  getForLineItem(lineItemId: string): Observable<any[]> {
    return this.client.request<any[]>({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['bidupdates', 'lineitem', lineItemId]),
      params: {}
    });
  }
}
